import { EducatorsListingProfileItem } from "@/types/serializers"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { ListingTypeBadge } from "./listing-type-badge"

export function ListingCard({
  listing,
  children,
}: {
  listing: EducatorsListingProfileItem
  children: React.ReactNode
}) {
  return (
    <Card data-testid="profile-listing-card">
      <CardHeader className="flex flex-row flex-wrap items-center justify-between align-bottom text-2xl font-medium">
        <div className="flex flex-row gap-2">
          <CardTitle>{listing.name}</CardTitle>
          <ListingTypeBadge
            listingType={listing.listing_type}
            className="text-sm"
          />
        </div>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        <ul className="grid w-full grid-cols-2 gap-4">{children}</ul>
      </CardContent>
    </Card>
  )
}
